function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from "react";
import { SCORM } from "pipwerks-scorm-api-wrapper";
/**
 * @class withSCORM
 * @extends {Component}
 */

export function withSCORM(WrappedComponent) {
  return /*#__PURE__*/function (_React$Component) {
    _inherits(_class, _React$Component);

    var _super = _createSuper(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);
      _this.scorm = false;
      _this.xapi = null;
      return _this;
    }

    _createClass(_class, [{
      key: "init",
      value: function init() {
        var disable_scorm = this.props.config.meta.disable_scorm;

        if (!disable_scorm) {
          this.scorm = SCORM.init();
        }
      }
    }, {
      key: "completeObjective",
      value: function completeObjective(min, max, score, status) {
        if (this.scorm) {
          var objectiveId = SCORM.get("cmi.objectives._count");
          SCORM.set("cmi.objectives.".concat(objectiveId, ".id"), "Gameo_Obj_".concat(objectiveId));
          SCORM.set("cmi.objectives.".concat(objectiveId, ".status"), status);
          SCORM.set("cmi.objectives.".concat(objectiveId, ".score.min"), min);
          SCORM.set("cmi.objectives.".concat(objectiveId, ".score.max"), max);
          SCORM.set("cmi.objectives.".concat(objectiveId, ".score.raw"), score);
        }
      }
    }, {
      key: "completeInteraction",
      value: function completeInteraction(type, result) {
        if (this.scorm) {
          var interactionId = SCORM.get("cmi.interactions._count");
          SCORM.set("cmi.interactions.".concat(interactionId, ".id"), "Gameo_Int_".concat(interactionId));
          SCORM.set("cmi.interactions.".concat(interactionId, ".result"), result);
          SCORM.set("cmi.interactions.".concat(interactionId, ".type"), type);
        }
      }
    }, {
      key: "save",
      value: function save() {
        SCORM.save();
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
          initSCORM: this.init.bind(this),
          completeObjective: this.completeObjective.bind(this),
          completeInteraction: this.completeInteraction.bind(this),
          save: this.save.bind(this)
        }, this.props));
      }
    }]);

    return _class;
  }(React.Component);
}